module.exports = "/cyber/_next/static/images/key-denomination-cover-354789890df6680e4498dbeac5106267.webp";